import type { SVGProps } from "react"

export default {
  VALID: `#000`, // `#51F2CB`,
  INVALID: `var(--warning)`,
}

export type Appearance = {
  dashArray: number[]
  strokeWidth: number
  strokeColor: string
}

export const appearanceToProps = (
  appearance: Appearance,
): SVGProps<SVGElement> => ({
  stroke: appearance.strokeColor,
  strokeWidth: appearance.strokeWidth,
  strokeDasharray: appearance.dashArray.join(`, `),
})
